<template>
  <div>
    <h4>Basic Setting</h4>
    <el-card>
      <el-form-item label="Source">
        <el-radio-group v-model="sourceRadio" size="mini">
          <el-radio-button label="blBcn">Bills and Credit Notes</el-radio-button>
          <el-radio-button label="po">Purchase Orders</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Date Range">
        <el-radio-group
          v-model="dateTypeRadio"
          size="mini"
          class="radio-container"
        >
          <el-radio-button label="date">Date</el-radio-button>
          <el-radio-button label="dueDate">Due Date</el-radio-button>
          <el-radio-button label="deliveryDate">ETA Date</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-model="dateRangePicker"
          type="daterange"
          range-separator="-"
          start-placeholder="From"
          end-placeholder="To"
          format="dd MMM yyyy"
          value-format="yyyy-MM-dd"
          size="mini"
          :style="{'margin-left':'20px'}"
        ></el-date-picker>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ReportBasicSetting',
  created () {
    this.setSource('blBcn')
    this.setDateType('date')
  },
  computed: {
    ...mapState('report', [
      'type',
      'source',
      'dateType',
      'dateRange'
    ]),
    sourceRadio: {
      get () {
        return this.source
      },
      set (val) {
        this.setSource(val)
      }
    },
    dateTypeRadio: {
      get () {
        return this.dateType
      },
      set (val) {
        this.setDateType(val)
      }
    },
    dateRangePicker: {
      get () {
        return this.dateRange
      },
      set (val) {
        this.setDateRange(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setSource: 'report/setSource',
      setDateType: 'report/setDateType',
      setDateRange: 'report/setDateRange'
    })
  }
}
</script>
